import { ReactComponent as ArrowLeftSvg } from '../../assets/icons/arrow-left.svg';

export const ArrowLeftIcon: SvgIcon = (props) => {
    return <ArrowLeftSvg {...props} />;
};
